export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const monthWithDays = {
    'Jan': 31, 'Feb': 29, 'Mar': 31, 'Apr': 30, 'May': 31, 'Jun': 30, 'Jul': 31,
    'Aug': 31, 'Sep': 30, 'Oct': 31, 'Nov': 30, 'Dec': 31
}
export const monthsWithValue = [
    { value: '1',
      label: 'Jan' },
      { value: '2',
      label: 'Feb' },
      { value: '3',
      label: 'Mar' },
      { value: '4',
      label: 'Apr' },
      { value: '5',
      label: 'May' },
      { value: '6',
      label: 'Jun' },
      { value: '7',
      label: 'Jul' },
      { value: '8',
      label: 'Aug' },
      { value: '9',
      label: 'Sep' },
      { value: '10',
      label: 'Oct' },
      { value: '11',
      label: 'Nov' },
      { value: '12',
      label: 'Dec' }];